export default __webpack_public_path__ + "static/media/cera_hero.9655a8f8.mp4";